import { render, staticRenderFns } from "./AddressLocation.vue?vue&type=template&id=736051e8&"
import script from "./AddressLocation.vue?vue&type=script&lang=js&"
export * from "./AddressLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports